import axios from "axios"
import { GIROS_ENDPOINT } from "../../../../../../utility/SourceAPI"


export const fetchGiros = async () => {
    const response = await axios.get(GIROS_ENDPOINT)
    return response.data
}

export const createGiro = async (giroData) => {
    const response = await axios.post(GIROS_ENDPOINT, giroData)
    return response.data
}

export const updateGiro = async (giroId, giroData) => {
    const response = await axios.put(GIROS_ENDPOINT.concat(`id/${giroId}`), giroData)
    return response.data
}